import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
    private translate = inject(TranslateService);

    constructor() {
        super();
        this.translate.onLangChange.subscribe(() => this.updateLabels());
        this.updateLabels();
    }

    private updateLabels(): void {
        this.itemsPerPageLabel = this.translate.instant('paginator.itemsPerPage');
        this.nextPageLabel = this.translate.instant('paginator.nextPage');
        this.previousPageLabel = this.translate.instant('paginator.previousPage');
        this.firstPageLabel = this.translate.instant('paginator.firstPage');
        this.lastPageLabel = this.translate.instant('paginator.lastPage');
        this.changes.next();
    }

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0) {
            return this.translate.instant('paginator.rangeEmpty');
        }

        const start = page * pageSize + 1;
        const end = Math.min((page + 1) * pageSize, length);
        
        return this.translate.instant('paginator.range', { start, end, length });
    };
}